import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { Avatar, AvatarBadge, AvatarGroup } from '@chakra-ui/react'
import { fetchUsers } from "../../../../redux/reducer/postFetcReducer/action/action";

export default function ChangeDirector({ creaTorTask, setcreaTorTask, onlineUsers, adminInfo }) {

  const dispatch = useDispatch();
  // здесь не получаем всех сотрудников на этой компании
  const gerChekcedCompany = useSelector((allWorkers) => allWorkers);
  const [users, setUsers] = useState([]);
  const [performer, setperformer] = useState("");
  const openModalRef = useRef(null)
  const getDarkModoe = useSelector(darkModes => darkModes);
  let onlineuser = useSelector(onlineUsers => onlineUsers)
  // здесь мы добавляем на состояние всех сотрудников




  useEffect(() => {
    console.log(performer);
    // This effect will run once when the component mounts.
    setUsers(gerChekcedCompany.rootReducer.users.data);
  }, []);

  useEffect(() => {

    // This effect will run when gerChekcedCompany.getMayInfoReducer.myinfo._id changes.
    if (gerChekcedCompany.getMayInfoReducer.myinfo._id == creaTorTask) {

      setperformer(gerChekcedCompany.getMayInfoReducer.myinfo);
    } else if (adminInfo._id == creaTorTask) {
      setperformer(adminInfo);
      console.log(performer);
    }
    else {
      for (let i = 0; i < users.length; i++) {
        if (users.workerID === creaTorTask) {
          setperformer(users);
        }

      }
    }

  }, [creaTorTask]);




  // После нажатия кнопку добавляем нового сотрудника и обновляем состояние
  const perfomer = (e) => {
    
    setperformer(e)
    console.log(e, "eqawewq");
    setcreaTorTask(e.workerID)
  };
  // здесь ищем сотрудника по номеру телефона и имени
  const searchPerfomer = (e) => {

    const regexPattern = new RegExp(e, 'i');
    let x = gerChekcedCompany.rootReducer.users.data.filter(item => regexPattern.test(item.name) || regexPattern.test(item.tel))
    setUsers(x)
    if (e == "") {
      dispatch(fetchUsers())
      setUsers(gerChekcedCompany.rootReducer.users.data)
    }

  }

  const openModal = () => {
    openModalRef.current.style.display = "flex"
    setUsers(gerChekcedCompany.rootReducer.users.data)
  }

  const closeModal = () => {
    openModalRef.current.style.display = "none"
  }


  return (
    <>
      <div id="myModal" ref={openModalRef} className={getDarkModoe.ToggleDarkModeReducer.chekced ? "modalPerfomerDark" : "modalPerfomer"}>


        <div className="modal-contentPerfomer">
          <div className="modal-headerPerfomer">
            <p>Изменить постановщика</p>
            <span class="close" onClick={closeModal}>&times;</span>

          </div>
          <div className="modal-bodyPerfomer">
            <label htmlFor="searchPerformer">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                <path d="M12.1498 10.6918H11.3819L11.1098 10.4294C12.0623 9.32133 12.6358 7.88279 12.6358 6.3179C12.6358 2.82847 9.80732 0 6.3179 0C2.82847 0 0 2.82847 0 6.3179C0 9.80732 2.82847 12.6358 6.3179 12.6358C7.88279 12.6358 9.32133 12.0623 10.4294 11.1098L10.6918 11.3819V12.1498L15.5517 17L17 15.5517L12.1498 10.6918ZM6.3179 10.6918C3.89766 10.6918 1.94397 8.73814 1.94397 6.3179C1.94397 3.89766 3.89766 1.94397 6.3179 1.94397C8.73814 1.94397 10.6918 3.89766 10.6918 6.3179C10.6918 8.73814 8.73814 10.6918 6.3179 10.6918Z" fill="#C3CAD9" />
              </svg>
              <input type="text" placeholder="Поиск" onChange={(e) => searchPerfomer(e.target.value)} id="searchPerformer" />
            </label>
            <div>


              <div className="executorCont">
                {users?.map(
                  (item, index) => {

                    return (
                      <div
                        key={index}
                        className="executor"
                        onClick={(e) => perfomer(item)}

                      >
                        <div>
                          {
                            (() => {
                              if (item.workerID == performer.workerID) {
                                return <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                                  <path d="M13.5 17.8538L19.3388 12.015L17.8875 10.5975L13.5 14.985L9.1125 10.5975L7.66125 12.015L13.5 17.8538ZM13.5 27C11.655 27 9.91125 26.6456 8.26875 25.9369C6.62625 25.2281 5.19187 24.2606 3.96563 23.0344C2.73938 21.8081 1.77188 20.3738 1.06313 18.7313C0.354375 17.0888 0 15.345 0 13.5C0 11.6325 0.354375 9.8775 1.06313 8.235C1.77188 6.5925 2.73938 5.16375 3.96563 3.94875C5.19187 2.73375 6.62625 1.77188 8.26875 1.06313C9.91125 0.354375 11.655 0 13.5 0C15.3675 0 17.1225 0.354375 18.765 1.06313C20.4075 1.77188 21.8363 2.73375 23.0513 3.94875C24.2663 5.16375 25.2281 6.5925 25.9369 8.235C26.6456 9.8775 27 11.6325 27 13.5C27 15.345 26.6456 17.0888 25.9369 18.7313C25.2281 20.3738 24.2663 21.8081 23.0513 23.0344C21.8363 24.2606 20.4075 25.2281 18.765 25.9369C17.1225 26.6456 15.3675 27 13.5 27ZM13.5 24.975C16.695 24.975 19.4062 23.8556 21.6337 21.6169C23.8612 19.3781 24.975 16.6725 24.975 13.5C24.975 10.305 23.8612 7.59375 21.6337 5.36625C19.4062 3.13875 16.695 2.025 13.5 2.025C10.3275 2.025 7.62188 3.13875 5.38312 5.36625C3.14437 7.59375 2.025 10.305 2.025 13.5C2.025 16.6725 3.14437 19.3781 5.38312 21.6169C7.62188 23.8556 10.3275 24.975 13.5 24.975Z" fill="#3B79F6" />
                                </svg>
                              } else {
                                return <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                                  <path d="M13.5 27C11.655 27 9.91125 26.6456 8.26875 25.9369C6.62625 25.2281 5.19187 24.2606 3.96563 23.0344C2.73938 21.8081 1.77188 20.3738 1.06313 18.7313C0.354375 17.0888 0 15.345 0 13.5C0 11.6325 0.354375 9.8775 1.06313 8.235C1.77188 6.5925 2.73938 5.16375 3.96563 3.94875C5.19187 2.73375 6.62625 1.77188 8.26875 1.06313C9.91125 0.354375 11.655 0 13.5 0C15.3675 0 17.1225 0.354375 18.765 1.06313C20.4075 1.77188 21.8363 2.73375 23.0513 3.94875C24.2663 5.16375 25.2281 6.5925 25.9369 8.235C26.6456 9.8775 27 11.6325 27 13.5C27 15.345 26.6456 17.0888 25.9369 18.7313C25.2281 20.3738 24.2663 21.8081 23.0513 23.0344C21.8363 24.2606 20.4075 25.2281 18.765 25.9369C17.1225 26.6456 15.3675 27 13.5 27ZM13.5 24.975C16.695 24.975 19.4062 23.8556 21.6338 21.6169C23.8613 19.3781 24.975 16.6725 24.975 13.5C24.975 10.305 23.8613 7.59375 21.6338 5.36625C19.4062 3.13875 16.695 2.025 13.5 2.025C10.3275 2.025 7.62188 3.13875 5.38313 5.36625C3.14438 7.59375 2.025 10.305 2.025 13.5C2.025 16.6725 3.14438 19.3781 5.38313 21.6169C7.62188 23.8556 10.3275 24.975 13.5 24.975Z" fill="#DADEE6" />
                                </svg>
                              }
                            })()
                          }

                        </div>

                        {
                          onlineuser.AllOnlineUsersReducer.allOnlineUsers?.includes(item.workerID) ?
                            <Avatar size="lg" name="Christian Nwamba" src={item.img ? item.img : "https://bit.ly/code-beast"} >
                              <AvatarBadge boxSize='0.9em' bg='green.500' />
                            </Avatar>
                            :
                            <Avatar size="lg" name="Christian Nwamba" src={item.img ? item.img : "https://bit.ly/code-beast"} />
                        }
                        <div className="performerInfo">
                          <p className="perfName">{item.name}-Постановщик </p>
                          <p className="perfTel"> Тел: {item.tel}</p>
                          <p className="perfEmail"> email: {item.email}</p>

                        </div>
                        
                      </div>
                    );
                  }
                )}
              </div>
             
            </div>
          </div>
          <div className="modal-footerPerfomer">
            <button onClick={closeModal}>Закрыть </button>
          </div>
        </div>

      </div>




      {
        (() => {
          if (performer != "") {
            return (
              <div>

                {
                  performer.tel ?
                    <div className={"performerTag"} >

                      <div style={{ display: 'flex' }} onClick={() => {
                        if (adminInfo._id == gerChekcedCompany.getMayInfoReducer.myinfo._id) {
                          openModal()

                        }

                      }}>

                        {
                          (()=>{
                              if (performer._id) {
                                  return  onlineuser.AllOnlineUsersReducer.allOnlineUsers?.includes(performer.workerID || performer._id) ?
                                  <Avatar size="lg" name="Christian Nwamba" src={ window.location.origin +"/"+ performer.img} style={{ marginRight: "5px", boxShadow: "0px 2px 3px 0px rgba(0, 0, 0, 0.15)" }} >
                                    <AvatarBadge boxSize='0.9em' bg='green.500' />
                                  </Avatar>
                                  :
                                  <Avatar size="lg" name="Christian Nwamba"  src={ window.location.origin +"/"+ performer.img}style={{ marginRight: "5px", boxShadow: "0px 2px 3px 0px rgba(0, 0, 0, 0.15)" }} />
                              }else  if (performer.workerID) {
                                return  onlineuser.AllOnlineUsersReducer.allOnlineUsers?.includes(performer.workerID || performer._id) ?
                                <Avatar size="lg" name="Christian Nwamba" src={ performer.img} style={{ marginRight: "5px", boxShadow: "0px 2px 3px 0px rgba(0, 0, 0, 0.15)" }} >
                                  <AvatarBadge boxSize='0.9em' bg='green.500' />
                                </Avatar>
                                :
                                <Avatar size="lg" name="Christian Nwamba"  src={ window.location.origin +"/"+ performer.img}style={{ marginRight: "5px", boxShadow: "0px 2px 3px 0px rgba(0, 0, 0, 0.15)" }} />
                            }
                          })()
                        }
                    
                      
                        <div>
                          {
                            performer.name ?
                              <p className="perfName">{performer.name}-Постановщик</p>
                              :
                              ""
                          }
                          {
                            performer.tel ?
                              <p className="perfTel">{performer.tel}</p>
                              :
                              ""
                          }
                          {
                            performer.email ?
                              <p className="perfEmail">{performer.email}</p>
                              :
                              ""
                          }

                        </div>

                      </div>

                      <span class="material-symbols-outlined" style={{opacity:"0.5",cursor:"no-drop"}}>delete</span>
                    </div>
                    :
                    ""
                }
              </div>
            )
          } else {
            return <button className="perfomerOpenModal" onClick={openModal}>Изменить постановщика</button>
          }
        })()
      }


      {/* =========================================================== */}


    </>
  )
}